module.exports = __webpack_public_path__ + "static/media/pasImage.b88a5a86.jpg";